// Angular
import { inject, Injectable } from '@angular/core';
// Services
import { LocalStorageService } from '@core/modules/local-storage/local-storage.service';
// Models
import { StorageKey } from '@core/storage/storage-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class CustomerAddressStorageService {
  private readonly localStorageService = inject(LocalStorageService);

  /**
   * Obtener la dirección guardada.
   * @returns
   */
  getSavedAddress(): any | null {
    return this.localStorageService.get(StorageKey.SAVED_ADDRESS) || null;
  }

  /**
   * Establecer la dirección guardada.
   * @param address
   */
  setSavedAddress(address: any | null): void {
    this.localStorageService.set(StorageKey.SAVED_ADDRESS, address);
  }

  /**
   * Eliminar la dirección guardada.
   */
  removeSavedAddress(): void {
    this.localStorageService.remove(StorageKey.SAVED_ADDRESS);
  }
}
